<template>
  <v-card style="min-width:650px;" elevation="0">
    <v-list class="branded-background">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">link</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title class="modal-title">
            <span class="text-white text-truncate-popover">Share copy link for "{{playlist.name}}"</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <div class="tab-item-container">
      <div class="class-info-container">
        <div class="preview-info">
          <span>This link is <span class="font-weight-bold">not</span> for learner use.  Share this link to allow other instructors to copy this playlist.
          <br>By default instructors will be able to fully copy a playlist. This includes all content (bulbs, attachments) and the ability to add, change, and remove items.  You can limit this functionality by enabling facilitator copies using the toggle below.</span>
        </div>
      </div>
      <div class="copy-container">
        <v-text-field 
          box
          hide-details
          readonly
          :value="copyPlaylistUrl"
          :disabled="playlistModalLoading"></v-text-field>
        <ClipboardCopy :copyText="copyPlaylistUrl"></ClipboardCopy>
      </div>
      <v-list>
        <v-list-tile
          v-if="showSamlToggle"
          class="ml-3">
          <v-switch
            id="SAMLToggle"
            light
            dense
            class="py-0"
            :color="playlist.default_color"
            v-model="SAMLLogin"
            label="Enable SAML login"
            hide-details
          ></v-switch>
        </v-list-tile>
        <v-list-tile
          class="ml-3">
          <v-list-tile-content
            :style="facilitatorCopyBox"
            >
            <v-switch
              id="facilitatorCopyToggle"
              light
              dense
              class="py-0 d-inline-block"
              :color="playlist.default_color"
              v-model="facilitatorCopy"
              label="Facilitator copies"
              hide-details
              @change="updatePlaylistCopy"
            ></v-switch>
            <Tooltip
              :attach="'.facilitatorCopyTooltip'"
              top>
              <v-icon
                size=20
                class="ml-2 mb-1 facilitatorCopyTooltip d-inline-block">info</v-icon>
              <template v-slot:text>
                {{ copyInfoText }}
              </template>
            </Tooltip>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </div>
    <v-card-actions class="row-space" style="height:56px">
     <v-btn
      flat
      class="branded-grey"
      @click="setDashModal(null)"
      :loading="playlistModalLoading"
      >Close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import _ from 'lodash';
import ClipboardCopy from '@/components/buttons/clipboardCopy';
import Hashids from 'hashids';

const hashids = new Hashids('dachshund', 6, 'cdefhjkmnprtvwxy2345689');

export default {
  name: 'CopyPlaylistLink',
  components: {
    ClipboardCopy,
  },
  props: [
    'playlist', 
  ],
  data: () => ({
    facilitatorCopy: false,
    facilitatorCopyBox: {
      flexDirection: 'row',
      flex: 'none',
    },
    SAMLLogin: false,
  }),
  computed: {
    ...mapState('instructors', [
      'playlistModalLoading',
    ]),
    ...mapGetters([
      'phpApiPrefix',
      'school',
    ]),
    copyInfoText() {
      if (this.facilitatorCopy) return 'Users will be able to make a Facilitator Copy.  They will not be able to make any changes to the playlist or the content inside it.';
      return 'Users will be able to fully copy playlist (including bulbs and attachments) and make changes to the new copy.';
    },
    copyPlaylistUrl() {
      if (this.SAMLLogin) return `${this.phpApiPrefix}/saml/${this.school.id}?redirect=/playlist/${hashids.encode(this.playlist.id)}/copy`;
      return `${this.phpApiPrefix}/playlist/${hashids.encode(this.playlist.id)}/copy`;
    },
    showSamlToggle() {
      return _.get(this.school, 'permissionKeys', []).includes('hasSamlLogin');
    }
  },
  methods: {
    ...mapActions('instructors', [
      'updatePlaylistCopySetting',
    ]),
    ...mapMutations([
      'setDashModal',
    ]),
    async updatePlaylistCopy() {
      const facilitatorCopyValue = await this.updatePlaylistCopySetting({
        id: this.playlist.id,
        facilitatorCopy: this.facilitatorCopy,
      });
      this.facilitatorCopy = facilitatorCopyValue;
    },
  },
  mounted() {
    this.SAMLLogin = _.get(this.school, 'config.enableSamlByDefault', false);
    this.facilitatorCopy = _.get(this.playlist, 'config.facilitatorCopy', false);
  },
};
</script>
